<template>
  <div>
    <transition name="fade">
      <div v-if="loaded">
        <div v-for="(item, index) in items" v-bind:key="index">
          <div v-if="item.longDescription != ''">
            <a v-if="showImage" :href="basedir + item.urlPrefix + item.url.split('?')[0]"><img :alt="item.headers" v-lazy="item.imageUrl.indexOf('http') < 0 ? basedir + item.imageUrl+'?w=285&quality=100' : item.imageUrl+'?w=285&quality=100'">
              <p class="typeBadge" v-if="typeof item.section != 'undefined' && item.section.length != 0">{{item.section}}</p>
            </a>
            <a class="headline" :href="basedir + item.urlPrefix + item.url.split('?')[0]">{{item.headers.length > 50 ? item.headers.slice(0, 50)+"..." : item.headers}}</a>
            <p class="date">{{new Date(item.publicationDate).toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric' })}}</p>
            <p class="excerpt">{{item.description.length > 100 ? item.description.slice(0, 100)+"..." : item.description}}</p>
            <a class="readMore" :href="basedir + item.urlPrefix + item.url.split('?')[0]"><webmessage searchKey="wsm_ReadMore" :text="$root.language.wsm_ReadMore"></webmessage> <font-awesome-icon :icon="['fas', 'angle-right']" /></a>
            <hr>
          </div>
        </div>
      </div>
    </transition>
    <div v-if="!loaded">
      <div class="loadContainer" v-for="n in resultNo" v-bind:key="n">
        <vue-content-loading v-if="showImage" :rtl="true" :width="20000" :height="12000" :speed="1">
          <rect x="75" y="13" rx="4" ry="4" width="100%" height="100%" />
        </vue-content-loading>
        <vue-content-loading :rtl="true" :width="20000" :height="3000" :speed="1">
          <rect x="75" y="13" rx="4" ry="4" width="100%" height="100%" />
        </vue-content-loading>
        <vue-content-loading :rtl="true" :width="500" :height="32" :speed="1">
          <rect x="75" y="13" rx="4" ry="4" width="100%" height="100%" />
        </vue-content-loading>
        <vue-content-loading :rtl="true" :width="400" :height="31" :speed="1">
          <rect x="75" y="13" rx="4" ry="4" width="100%" height="100%" />
        </vue-content-loading>
        <vue-content-loading :rtl="true" :width="600" :height="32" :speed="1">
          <rect x="75" y="13" rx="4" ry="4" width="100%" height="100%" />
        </vue-content-loading>
        <vue-content-loading style="margin-top:-10px;margin-bottom:-8px;" :rtl="true" :width="175" :height="29" :speed="1">
          <rect x="75" y="13" rx="4" ry="4" width="100%" height="100%" />
        </vue-content-loading>
        <hr>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["items", "loaded", "showImage", "resultNo"],
    computed: {
      basedir: function() {
        return basedir;
      },
      locale: function() {
        return window.locale.replace('_', '-')
      },
    }
  }
</script>

<style lang="scss" scoped>
  img {
    width: 100%;
    margin-bottom: 5px;
    border-radius: 5px;
    margin-top: 10px;
    max-width: 354px;
    box-shadow: 2px 2px 20px #cacaca;
  }
  .headline {
    color: #004570;
    font-weight: bold;
    text-transform: uppercase;
    display: inline;
    margin-right: 9px;
  }
  .date {
    display: inline-block;
    font-size: 0.8em;
    color: #828282;
    margin-bottom: 0;
  }
  .excerpt {
    color: #696969;
    font-size: 0.8em;
    margin: 0;
    margin-bottom: 5px;
  }
  .readMore {
    margin-top: 7px;
    margin-bottom: 10px;
    display: inline-block;
    .fa-angle-right {
      vertical-align: middle;
      margin-left: 2px;
      margin-top: -1px;
      transition: all 0.2s ease-in-out;
    }
    &:hover {
      .fa-angle-right {
        margin-left: 5px;
      }
    }
  }
  .readMoreLoader {
    margin-top: -25px;
    margin-bottom: -15px;
  }
  .typeBadge {
    float: right;
    margin-bottom: 0;
    display: block;
    margin-top: -32px;
    margin-right: -8px;
    font-weight: bold;
    text-transform: uppercase;
    position: relative;
    color: white;
    background: #004570;
    box-shadow: 2px 2px 3px 0px gainsboro;
    padding: 3px;
    padding-left: 6px;
    border-radius: 3px;
    padding-right: 6px;
  }
</style>